import { useCallback as e, useState as t } from "react";
//#region src/components/DatePicker/hooks/useRangeSelection.ts
function n({ start: n, end: r, lockStart: i = !1, onSelect: a, initialPicking: o, impossibleRange: s, nextBlockedFrom: c, picking: l, setPicking: u }) {
	let [d, f] = t(o ?? (i && n ? "end" : "start")), p = l ?? d, m = u ?? f;
	return {
		picking: p,
		setPicking: m,
		handleDayClick: e((e) => {
			if (i) {
				n && e > n && (a({
					start: n,
					end: e
				}), m("end"));
				return;
			}
			p === "start" || n && r || p === "end" && n && (s || c && e > c) ? (a({
				start: e,
				end: null
			}), m("end")) : (a(n && e < n ? {
				start: e,
				end: n
			} : {
				start: n,
				end: e
			}), m("start"));
		}, [
			i,
			n,
			r,
			p,
			m,
			a,
			s,
			c
		])
	};
}
//#endregion
export { n as useRangeSelection };
